import axios from "axios";
import { store } from "../store";
import { setError } from "../OSCI/src/slice/errorModalSlice";
import { getApiBaseUrl, handleClearDetails } from "../utils/helper";
import { constant } from "./constant";
import i18n from "../i18n";
import { getDeviceType, getLocationName, getMarkets, getSessionId, getUserType } from "../DAPI/src/component/check-in/select-passengers/flightStatusHelper";
import { ErrorData, hashToUpperCase } from "../utils/datalayer";
//process.env variable to be added
//apiconfig/ apiconstants to be added
const api = axios.create({
  baseURL: getApiBaseUrl("api")
});
let numberOfAjaxCAllPending = 0;

// Request interceptor
api.interceptors.request.use(config => {
  // Modify the request config here (e.g., add headers, authentication tokens)
  //const accessToken:any = JSON.parse(sessionStorage.getItem("token") || '{}') ;
  // ** If token is present add it to request's Authorization Header
  // if (Object.keys(accessToken).length > 0) {
  //   if (config.headers) {
  //     config.headers.token = `Bearer ${accessToken}`;
  //   }
  // }
  if (config?.loader) {
    numberOfAjaxCAllPending++;
    document.documentElement.style.setProperty("--suspense-loading-spinner", "none");
    document.documentElement.style.setProperty("--loading-spinner", "block");
  }
  if (config.headers) {
    config.headers.source = `website`;
    config.headers.hostName = window.location.origin;
    config.headers["Accept-Language"] = config.headers["Accept-Language"] || i18n?.language;
  }
  const authToken = typeof window !== "undefined" && window?.localStorage?.getItem("accesstoken");
  const isRopEnabled = sessionStorage?.getItem("isROPEnabled") === "true" ? true : false;
  if (authToken) {
    if (isRopEnabled) {
      config.headers["App-Authorization"] = authToken;
    } else {
      config.headers.Authorization = authToken;
    }
  }
  if (!isRopEnabled && (config?.headers?.Authorization?.includes("Basic") || config?.url?.startsWith("/custom_config"))) {
    delete config.headers.Authorization;
  } else if (isRopEnabled && config?.headers?.["App-Authorization"]?.includes("Basic") || config?.url?.startsWith("/custom_config")) {
    delete config.headers["App-Authorization"];
  }
  const checkInAuthToken = typeof window !== "undefined" && window?.sessionStorage?.getItem("checkintoken");
  if (checkInAuthToken && window.location?.pathname?.toLowerCase()?.includes("checkin")) {
    config.headers.AccessToken = checkInAuthToken;
  }
  return config;
}, error => {
  // Handle request errors here

  return Promise.reject(error);
});

// Response interceptor
api.interceptors.response.use(response => {
  // Modify the response data here (e.g., parse, transform)
  if (response?.config?.loader) {
    numberOfAjaxCAllPending--;
  }
  if (numberOfAjaxCAllPending === 0) {
    document.documentElement.style.setProperty("--loading-spinner", "none");
    document.documentElement.style.setProperty("--suspense-loading-spinner", "block");
  }

  // document.documentElement.style.setProperty("--loading-spinner", "none");
  return response;
}, error => {
  if (error?.config?.isGenericErr) {
    const errorStatus = error?.response?.status || error?.status;
    const errorCode = error?.response?.data?.code ?? null;
    const errorRequestUrl = error?.config?.url ?? error?.response?.request?.responseURL;
    const isDapi = errorRequestUrl.includes("check-in") || errorRequestUrl.includes("/ancillaries/checkin");
    const isPreSelectMeal = errorRequestUrl.includes("preselect-meal") || errorRequestUrl.includes("/preselect-meal/meal-list");
    const isLoungeFinder = errorRequestUrl.includes("loungeFinder") || errorRequestUrl.includes("/more-services/loungeFinder");
    const isRopEnabledUrl = errorRequestUrl?.includes("/v1/tg-missing-miles") || errorRequestUrl?.includes("v1/star-alliance-missing-miles");
    const forgotMemberUrl = errorRequestUrl?.includes("/v1/forgotMemberId");
    // Handle response errors here
    if (error.code === "ERR_NETWORK") {
      store.dispatch(setError({
        message: i18n.t("error_network_failed"),
        heading: "Network Error",
        buttonText: i18n.t("button_too_many_codes_ok")
      }));
    } else if (errorStatus === 401 || errorStatus === 403) {
      if (isDapi) {
        // Handle unauthorised scenario
        store.dispatch(setError({
          message: i18n.t("error_session_expired_msg"),
          heading: i18n.t("label_session_expired_heading"),
          buttonText: i18n.t("button_consent_back"),
          errCode: errorStatus,
          isLoginReq: false,
          type: "checkin-token-expired",
          messageIcon: "expired-timer-icon"
        }));
      } else {
        // Handle unauthorised scenario
        const expiryTime = window.localStorage.getItem("expireTime");
        const accessToken = localStorage.getItem("accesstoken");
        const isROPLoggedInFlag = localStorage.getItem("isROPLoggedIn");
        const isCRMLoggedInFlag = localStorage.getItem("isCRMLoggedIn");
        const isAuth = accessToken !== null && (isROPLoggedInFlag === "true" || isCRMLoggedInFlag === "true");
        if (expiryTime && new Date() - new Date(expiryTime) > 3600000 || !isAuth) {
          handleClearDetails();
          if (window.location.href.includes("/rop") || window.location.href.includes("/member") || window.location.href.includes("/help")) {
            window.location.replace(`${window.location.origin}/${i18n?.language}`);
          } else {
            if (!forgotMemberUrl) {
              window.location.reload();
            }
          }
        } else {
          const checkDapiPaths = constant?.dapiPaths;
          const isDapiPath = () => {
            return checkDapiPaths?.some(item => location.pathname?.includes(item));
          };
          if (!isDapiPath()) {
            store.dispatch(setError({
              message: i18n.t("error_unauthorised"),
              heading: errorStatus === 401 ? i18n.t("label_unauthorised") : i18n.t("error_login_session_expired"),
              buttonText: i18n.t("label_enroll_sign_in"),
              errCode: errorStatus,
              isLoginReq: true,
              type: "sessionExpired"
            }));
          } else {
            sessionStorage?.setItem("bookingExpired", "true");
            window.dispatchEvent(new Event("storage"));
          }
        }
      }
    } else if (errorStatus === 500 || errorStatus === 501 || errorStatus === 502 || errorStatus === 503 || errorStatus === 504 || errorStatus === 400 && !isDapi && errorCode !== "40100007" && errorCode !== "E7201") {
      if (errorStatus === 400 && errorCode === "E7007" && isLoungeFinder) {
        store.dispatch(setError({
          message: `${i18n.t("label_couldnt_find_any_matching_result")} ${i18n.t("label_please_try_diff_location")}`,
          heading: error?.response?.data?.message,
          buttonText: i18n.t("button_too_many_codes_ok")
        }));
      } else if (errorStatus === 400 && errorCode === "0005" && isPreSelectMeal) {
        store.dispatch(setError({
          message: i18n.t("error_request_failed"),
          heading: i18n.t("label_preselect_meal_unavailable"),
          buttonText: i18n.t("button_too_many_codes_ok")
        }));
      } else {
        if (!isRopEnabledUrl) {
          store.dispatch(setError({
            message: i18n.t("error_request_failed"),
            heading: i18n.t("label_server_error"),
            buttonText: i18n.t("button_too_many_codes_ok")
          }));
        }
      }
    } else if (errorStatus === 404 || errorStatus === 405 || errorStatus === 408 || errorStatus === 429) {
      store.dispatch(setError({
        message: i18n.t("error_request_failed"),
        heading: "Client Error",
        buttonText: i18n.t("button_too_many_codes_ok")
      }));
    } else if (errorStatus === 406 && !error?.config?.isBadRequestExceptional) {
      const state = store?.getState();
      const errorCodes = state?.dapiReducer?.errorCodeJson?.errorCodes;
      const getPnr = state?.dapiReducer?.checkin?.checkinPnr;
      const errorMsg = errorCodes?.errorEntries;
      const errorCode = error?.response?.data?.errors?.[0]?.code;
      const msg = errorMsg?.filter(item => item?.errorCode === errorCode);
      const description = msg !== undefined && msg !== null ? msg[0]?.errorMessage : i18n.t("error_biometric_pass");
      const errorGtm = {
        error_Id: errorCode,
        error_text: description,
        pnr_record_locator: getPnr?.pnr,
        pageName: getLocationName(),
        Login_status: getUserType("status"),
        primaryCategory: constant?.dapiDataLayer?.page_error_checkin_category,
        userId: sessionStorage.getItem("memberId") ? hashToUpperCase(sessionStorage.getItem("memberId")) : "NA",
        siteLanguage: getMarkets("language"),
        siteCountry: getMarkets("country"),
        platform: getDeviceType(),
        market: getMarkets("market"),
        userType: getUserType("type"),
        tsession_id: getSessionId()
      };
      ErrorData(errorGtm);
      if (errorCode === "40004") {
        sessionStorage.setItem("insuranceFailed", "true");
      }
      store.dispatch(setError({
        message: description,
        heading: errorCode === "40004" ? i18n.t("error_insurance_failed") : i18n.t("error_biometric_pass_heading"),
        buttonText: i18n.t("button_ok"),
        type: errorCode === "40004" ? "insuranceFailed" : "badrequest"
      }));
    }
  }
  if (error?.config?.loader) {
    numberOfAjaxCAllPending--;
  }
  if (numberOfAjaxCAllPending === 0) {
    document.documentElement.style.setProperty("--loading-spinner", "none");
    document.documentElement.style.setProperty("--suspense-loading-spinner", "block");
  }
  return Promise.reject(error);
});
export default api;